import { ConcreteEncodable } from "./ConcreteEncodable";

import { SalesGroupImplEncoder } from "../../encoder/SalesGroupImplEncoder";

import * as CubiqTS from "../../index";
import { SalesGroup } from "../SalesGroup";

export class SalesGroupImpl extends ConcreteEncodable implements SalesGroup {
  public static enType: string = "com.bcdfx.model.SalesGroupImpl";

  /*FID=1*/
  public groupId: CubiqTS.Long | null = null;
  /*FID=2*/
  public groupCode: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SalesGroupImplEncoder.Instance;
    this.setEncodableType(SalesGroupImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SalesGroupImpl[" +
      "groupId=" +
      this.groupId +
      "groupCode=" +
      this.groupCode +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
